import { message } from 'antd'
import { SalariesApi } from '../../../../api/People/Salaries'
import SalariesLines from '../../../../components/People/Salaries/Lines/SalaryLines'
import React from 'react'

import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'
import { get, isEmpty } from 'lodash'

function SalaryLinesCont (props) {
  const { salary, isUpdatable, setMain } = props
  const { list, fetching, fetch: f } = useFetchList(
    () => SalariesApi.lines.list(salary._key),
    [salary._key],
    isEmpty(salary._key),
  )

  async function fetch () {
    await f()
    const updatedSalary = await SalariesApi.get(salary._key)
    setMain(updatedSalary)
  }

  const {
    visible,
    modalType,
    object: line,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    checkForm,
  } = useModalData(undefined, undefined, SalariesApi.lines.remove, fetch)

  async function update () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await SalariesApi.lines.update({
        _id: get(line, ['_id']),
        ...newObject,
        salary: { _id: salary._id },
      })
      onCancel()
      fetch()

      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  async function submit () {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await SalariesApi.lines.create({
        ...newObject,
        salary: { _id: salary._id },
      })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <SalariesLines
      {...{
        list,
        fetching,
        fetch,
        visible,
        submitting,
        salary,
        line,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        isUpdatable,
      }}
    />
  )
}

SalaryLinesCont.propTypes = {}
SalaryLinesCont.defaultProps = {}

export default (SalaryLinesCont)
